export default __webpack_public_path__ + "static/media/Blog12.7.07eea5ec.png";